module.exports = __webpack_public_path__ + "img/CloseModalIcon.c42c668b.svg";